import { Globals } from "../CoreApp/Globals";
import { RoundTo3 } from "./RoundTo3";
import { XML_AddLink } from "./XML_AddLink";

export function XML_AddLinkToPDF(x0, y0, x1, y1, x2, y2, x3, x4, drawElement, linkBookmark) {
  if (linkBookmark == null || Globals._accountInfo.GetOC5Edition() == "ADP Basic") return;

  var xmin = RoundTo3(Math.min(x0, x1, x2, x3, x4) - 2);
  var xmax = RoundTo3(Math.max(x0, x1, x2, x3, x4) + 2);
  var ymin = RoundTo3(Math.min(y0, y1, y2) - 2);
  var ymax = RoundTo3(Math.max(y0, y1, y2) + 2);

  XML_AddLink(drawElement, linkBookmark, xmin, ymin, xmax, ymax);
}
